import(/* webpackMode: "eager" */ "/codebuild/output/src2422654294/src/src/app/global-error.tsx");
